<vs-app-page
  *vsLet="((paginationConfig$ | async)?.totalItems ?? null) as totalItems"
  [config]="{
    icon: 'tool-02',
    title: 'Service Providers',
    showDivider: true,
    description: 'This is an overview of all repair facilities and service providers for your organization.'
  }"
>
  <vs-breadcrumbs slot="breadcrumbs" [config]="{ items: [{ label: 'Service Providers' }] }"></vs-breadcrumbs>

  <vs-badge slot="title-end" [class.italic]="totalItems === null" [class.animate-pulse]="totalItems === null">
    <ng-container *ngIf="totalItems !== null; else loadingCount">
      {{ totalItems | number }} {{ totalItems === 1 ? 'Service Provider' : 'Service Providers' }}
    </ng-container>
    <ng-template #loadingCount>loading</ng-template>
  </vs-badge>

  <ng-template #newServiceProvider>
    <button *ngIf="canCreate$ | async" vs-button theme="primary" (click)="createDialog.open()">
      <vs-icon name="plus"></vs-icon>
      New Service Provider
    </button>
  </ng-template>

  <!-- The empty state carries the button when there is nothing to list, so show it here otherwise. -->
  <div slot="header-end" class="flex justify-end w-full sm:max-w-min">
    <ng-container
      *ngIf="(totalItems ?? 0) > 0 || hasActiveFilters"
      [ngTemplateOutlet]="newServiceProvider"
    ></ng-container>
  </div>

  <div class="flex gap-2 justify-between items-center flex-wrap mt-4">
    <vs-select
      vsInput
      class="w-[200px]"
      [config]="{ placeholder: 'All statuses', allowDeselect: true }"
      [value]="filters.status ?? null"
      (valueChanges)="onStatusChange($event)"
    >
      <li *ngFor="let status of statuses" vs-select-option [value]="status">
        <vs-badge [theme]="getTheme(status)" [config]="{ displayStatusIcon: true }">{{ status | titlecase }}</vs-badge>
      </li>
    </vs-select>

    <vs-input-container class="min-w-[220px] sm:max-w-[256px] w-full sm:w-auto">
      <vs-icon name="search-lg" slot="start"></vs-icon>
      <input
        #searchInput
        vsInput
        [value]="filters.search ?? ''"
        placeholder="Search service providers..."
        (input)="searchInput$.next(searchInput.value)"
      />
    </vs-input-container>
  </div>

  <vs-card class="overflow-hidden my-4">
    <ng-container
      *vsLet="{ serviceProviders: serviceProviders$ | async, paginationConfig: paginationConfig$ | async } as data"
    >
      <ng-container *ngIf="data">
        <vs-table-skeleton
          *ngIf="!data.serviceProviders"
          [rows]="5"
          [columns]="6"
          [columnDefs]="[
          { type: 'text' },
          { type: 'text' },
          { type: 'text' },
          { type: 'badge' },
          { type: 'date' },
          { type: 'date' }
        ]"
          [showHeader]="true"
          [banding]="true"
        ></vs-table-skeleton>

        <ng-container *ngIf="data.serviceProviders && data.paginationConfig && data.paginationConfig.totalItems > 0">
          <vs-table
            [columns]="columns"
            [data]="data.serviceProviders.items"
            (rowClicked)="navigateTo($event.id)"
            (sortChanged)="onSortChanged($event)"
          ></vs-table>

          <vs-pagination [config]="data.paginationConfig" (pagination)="pagination$.next($event)"></vs-pagination>
        </ng-container>

        <vs-empty-state
          *ngIf="data.serviceProviders && data.paginationConfig?.totalItems === 0"
          class="p-8"
          [config]="{
          title: hasLoadError
            ? 'Unable to load service providers.'
            : hasActiveFilters
              ? 'No service providers match your filters.'
              : 'No service providers yet.',
          subtitle: hasLoadError
            ? 'Something went wrong. Please refresh the page or try again later.'
            : hasActiveFilters
              ? 'Try a different search or clear the status filter.'
              : 'Once a service provider has been added, their details will appear here.',
          imgsrc: 'empty-clipboard'
        }"
        >
          <ng-container
            *ngIf="!hasActiveFilters && !hasLoadError"
            slot="button"
            [ngTemplateOutlet]="newServiceProvider"
          ></ng-container>
        </vs-empty-state>
      </ng-container>
    </ng-container>
  </vs-card>
</vs-app-page>

<ws-create-service-provider-dialog #createDialog (closed)="navigateTo($event)"></ws-create-service-provider-dialog>
